import { render, staticRenderFns } from "./Product_setting.vue?vue&type=template&id=c0afc68a&scoped=true&"
import script from "./Product_setting.vue?vue&type=script&lang=js&"
export * from "./Product_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0afc68a",
  null
  
)

export default component.exports